module.exports = __webpack_public_path__ + "img/Cepheus.261c89b3.png";